import React from 'react';
import { Download, Plus } from 'lucide-react';
import BulkScanButton from './prospect/BulkScanButton';

interface ProspectsHeaderProps {
  prospectsCount: number;
  viewedCount: number;
  quizCompletedCount: number;
  highScoreCount: number;
  appointmentCount: number;
  onAddClick: () => void;
  onExportClick: () => void;
  onScanComplete?: () => void;
}

const ProspectsHeader: React.FC<ProspectsHeaderProps> = ({
  prospectsCount,
  viewedCount,
  quizCompletedCount,
  highScoreCount,
  appointmentCount,
  onAddClick,
  onExportClick,
  onScanComplete
}) => {
  return (
    <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-blue-600 to-indigo-800 text-white shadow-xl mb-8 p-6">
      {/* Éléments décoratifs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10">
        <div className="absolute -top-10 -left-10 w-40 h-40 bg-white rounded-full blur-3xl"></div>
        <div className="absolute -bottom-10 -right-10 w-60 h-60 bg-blue-300 rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
          <div>
            <h1 className="text-3xl font-bold mb-2">Gestion des Prospects</h1>
            <p className="text-blue-100 mb-2">Total: {prospectsCount} prospects</p>
          </div>
          <div className="flex gap-3 mt-4 md:mt-0">
            <button
              onClick={onAddClick}
              className="flex items-center bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white px-4 py-2 rounded-lg transition-colors shadow-sm"
            >
              <Plus className="w-4 h-4 mr-2" />
              Ajouter Prospect
            </button>
            <button
              onClick={onExportClick}
              className="flex items-center bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white px-4 py-2 rounded-lg transition-colors shadow-sm"
            >
              <Download className="w-4 h-4 mr-2" />
              Exporter CSV
            </button>
            {/* Bouton Bulk Scan avec marge pour une meilleure visibilité */}
            <div className="ml-2">
              <BulkScanButton onScanComplete={onScanComplete} />
            </div>
          </div>
        </div>
        
        {/* Statistiques résumées */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 text-center">
            <div className="text-xl font-bold">{viewedCount}</div>
            <div className="text-xs text-blue-100">Pages visitées</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 text-center">
            <div className="text-xl font-bold">{quizCompletedCount}</div>
            <div className="text-xs text-blue-100">Quiz complétés</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 text-center">
            <div className="text-xl font-bold">{highScoreCount}</div>
            <div className="text-xs text-blue-100">Scores élevés</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 text-center">
            <div className="text-xl font-bold">{appointmentCount}</div>
            <div className="text-xs text-blue-100">RDV planifiés</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProspectsHeader;
